import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { GlobalComponent } from "src/app/global/global.component";

@Component({
  selector: "app-splash",
  templateUrl: "./splash.component.html",
  styleUrls: ["./splash.component.scss"],
})
export class SplashComponent implements OnInit {
  loginData: any = {};
  interval: any;
  windowWidth: string;
  showSplash = true;
  constructor(public global: GlobalComponent, public router: Router , public ngxservice: NgxUiLoaderService) {
     this.ngxservice.start();
    this.interval = setInterval(() => {
      this.windowWidth = "-" + window.innerWidth + "px";
      this.loginData = localStorage.getItem("CFSS_login");
      this.loginData = JSON.parse(this.loginData);

      if (this.global.isassignboolean == true) {
        if (this.global.OnboardingLoginType == "agencyLogin") {
           if (this.global.agencyCode?.toLocaleUpperCase() == "SUPERADMIN") {
             this.router.navigateByUrl("/agency");
              
           }
           else 
           {
              this.router.navigateByUrl("/active-session");
              
           }
            this.global.getAgencySetting();
            this.global.getLocation();
         
        } else if (this.global.OnboardingLoginType == "onboardLogin") {
          this.router.navigateByUrl("/client-employee-form");
           this.global.getAgencySetting();
        }
      }
    }, 3000);
  }
  ngOnDestroy() {
    this.ngxservice.stop();
    clearInterval(this.interval);
  }
  ngOnInit(): void {}
}
